import internalApi from '@/utils/internalApi'
import Lang from './Lang'
import Swal from 'sweetalert2'

export default class ApiTokenViewer {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ApiTokenViewer(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#view)
    }

    #view = (event) => {
        event.preventDefault()

        internalApi
            .get(this.#element.href)
            .then(function (response) {
                Swal.fire({
                    icon: 'success',
                    title: Lang.get('api_token.api_token'),
                    html:
                        '<textarea class="form-control font-code border-0" rows="7">' +
                        response.data.data.attributes.token +
                        '</textarea>',
                })
            })
            .catch(function (error) {
                Swal.fire({
                    icon: 'error',
                    title: Lang.get('general.oops'),
                    text: Lang.get('api_token.actions.show.failed'),
                })
            })
    }
}
